// Huquqlar katalogi — 04-ROLES.md §3 ning aynan ko'chirmasi.
//
// NEGA KODDA, BAZADAN OLINMAYDI: bazada bo'lmagan huquq nomi yozilib qolsa,
// u hech qachon tekshirilmaydi va jimgina "ruxsat yo'q" bo'lib qoladi.
// Ro'yxat kodda turganda esa nomuvofiqlik kompilyatsiyada ushlanadi.
//
// ⚠️ Bu ro'yxat backenddagi enum bilan BIR XIL bo'lishi shart. Backend yangi
// huquq qo'shsa — bu yerga ham qo'shiladi. Nomlar `<domen>.<resurs>.<amal>`
// shaklida va BARQAROR satr: ular bazada saqlanadi, o'zgartirilsa mavjud
// rollar huquqini yo'qotadi.

export const PERMISSIONS = [
  // Abonent
  'subscriber.read',
  'subscriber.history.view',
  'subscriber.contract.view',
  'subscriber.contract.manage',
  'subscriber.create',
  'voucher.activate',
  /*
    ⚠️ KATALOGDA BOR, LEKIN BU PANELDA HECH NARSAGA BOG'LANMAGAN — ATAYLAB.

    Kod backendda mavjud (`Permission.VOUCHER_STOCK_READ`) va u
    «o'zimning kartalarim» ro'yxatini ochadi — u SHERIK KABINETIDA
    (`frontend/partner`), admin panelida bunday sahifa YO'Q.

    ⛔ Uni menyuga yoki marshrutga bog'lash operatorga bo'sh ekran
    ochadigan yo'l qo'shardi. Bu yerda turishining yagona sababi —
    katalog backend ro'yxati bilan TO'LIQ mos bo'lishi kerak
    (`tests/permissions.mjs` ikki tomonlama tekshiradi): yetishmagan kod
    rol tahrirlash ekranida jimgina yo'qolib, o'sha huquqni saqlaganda
    rollardan CHIQIB KETARDI (fayl boshidagi izoh).
  */
  'voucher.stock.read',
  'subscriber.update',
  'subscriber.delete',
  'subscriber.block',
  'subscriber.password.set',
  'subscriber.session.disconnect',
  'subscriber.ratelimit.set',
  'subscriber.directory',
  'subscriber.devicetype.manage',
  'subscriber.visp.assign',

  // Katalog
  'plan.read',
  'plan.create',
  'plan.update',
  'plan.delete',
  'plan.price.set',
  'grant.issue',

  // Pul
  'payment.read',
  'payment.create',
  'payment.cancel',
  'ledger.read',
  'ledger.adjust',
  'agent.read',
  'agent.create',
  'agent.deposit.add',
  'agent.commission.set',
  'agent.fund',
  // Filial kassasi (ADR-039). `.read` bilan tugamaydi — ko'ruvchi rollarga o'z-o'zidan tushmasin.
  'cash.receipt.create',
  'cash.receipt.view',
  'cash.receipt.reverse',
  'cash.balance.view',
  'cash.entry.create',
  'cash.entry.approve',
  'cash.transfer.create',
  'cash.transfer.confirm',
  'cash.discount.apply',
  'cash.discount.approve',
  'cash.discount.policy',
  'cash.sale.credit',
  'cash.collect.limit.manage',
  'subscriber.debt.limit',
  'invoice.view',
  'invoice.create',
  'invoice.cancel',
  // Yetkazib beruvchi va xarid (xsib-finance), omborlararo ko'chirish (xsib-inventory).
  'supplier.view',
  'supplier.manage',
  'supplier.pay',
  'purchase.create',
  'purchase.verify',
  'purchase.receive',
  'inventory.transfer.dispatch',
  'inventory.transfer.receive',
  'inventory.transfer.price',
  'inventory.return.accept',
  'inventory.stock.opening',
  'inventory.stock.internaluse',
  // Ta'sischilar (xsib-finance). Tasdiqlash va to'lash — XAVFLI, pulga tegadi.
  'stakeholder.view',
  'stakeholder.manage',
  'stakeholder.distribution.approve',
  'stakeholder.pay',

  // Infratuzilma va hisobot
  'nas.read',
  'nas.create',
  'nas.update',
  'nas.delete',
  'network.visp.read',
  'network.visp.manage',
  'network.visp.quota',
  // Joylashuv reyestri (`site`) — NAS va jihoz qayerda turgani. Yozish
  // BITTA huquq (`site.write`): yaratish, tahrirlash va yopish bir xil
  // darajadagi amallar, o'chirish esa umuman yo'q (`sitesApi.ts`).
  'site.read',
  'site.write',
  // Viloyat/tuman ma'lumotnomasi (V202608640001). `geo.read` `%.read`
  // naqshiga tushadi — reestrda shaxsiy ma'lumot yo'q; `geo.write` esa
  // faqat ADMIN va SUPERADMIN da.
  'geo.read',
  'geo.write',
  // Inventar — backendda allaqachon bor, katalogda esa YO'Q edi. Ular
  // ro'yxatga qo'shilmaguncha `authApi.toCurrentUser` ularni jimgina
  // tashlab yuborardi va huquqi bor operator sahifani ko'ra olmasdi
  // (`user.update` bilan aynan shu bo'lgan — yuqoridagi izoh).
  'inventory.equipment.read',
  'inventory.equipment.write',
  'inventory.ip.read',
  'inventory.ip.manage',
  // Ombor va zaxira — `QARORLAR.md` §20.7 (6-qadam), manba:
  // `V202608131400__inventory_stock.sql` va
  // `uz.xsib.common.security.Permission`.
  //
  // ⚠️ `inventory.equipment.*` dan ALOHIDA: seriyali (router) va
  // miqdorli (kabel) mollar butunlay boshqa model (§20.8) va amalda
  // boshqa odam ishlatadi. Bitta kod bo'lsa, omborchiga abonentdagi
  // routerni hisobdan chiqarish huquqi ham tegib ketardi.
  //
  // ⚠️ `stock.adjust` `stock.write` dan ALOHIDA — u qoldiqni
  // KONTRAGENTSIZ o'zgartiradi (inventarizatsiya tuzatishi,
  // "yo'qoldi" deb hisobdan chiqarish) va backendda
  // `Permission.DANGEROUS` ro'yxatida, `ledger.adjust` bilan bir
  // toifada. Rol konstruktorida ular ALOHIDA belgilanishi kerak.
  'inventory.stock.read',
  'inventory.stock.write',
  'inventory.stock.adjust',
  'report.read',
  'report.export',
  'audit.read',
  'contact.read',
  'contact.write',
  'contact.reveal',
  'settings.read',
  'settings.update',
  // Tashkilot (tenant) hayot davri — PLATFORMA darajasidagi huquqlar.
  //
  // ⚠️ `settings.*` bilan chalkashtirmang: u "O'Z tashkilotimning
  // valyutasi/vaqt zonasi", bu esa "platformaga yangi tashkilot
  // qo'shaman". Backendda ular faqat SUPERADMIN shabloniga tushadi va
  // ustiga GLOBAL ko'rinish doirasi ham talab qilinadi
  // (`TenantAdminServiceImpl#requirePlatformOwner`) — ya'ni huquqning
  // o'zi yetarli emas.
  'tenant.read',
  'tenant.create',
  'tenant.update',

  // ⚠️ TASHKILIY DARAXT — `QARORLAR.md` §19, 2026-08-13 da qo'shildi.
  //
  // Bu uch kod backend'da `Permission` ga qo'shilgan zahoti shu yerga
  // ham yozilishi SHART. Sabab yuqoridagi `user.update` bilan bir xil
  // va bu loyihada AYNI XATO uch marta takrorlangan: katalogda
  // bo'lmagan kodni `authApi.toCurrentUser` **jimgina tashlaydi**.
  // Natija — huquqi BOR operatorga tugma KO'RINMAYDI, hech qanday
  // xato ham chiqmaydi, sabab esa butunlay boshqa joyda izlanadi.
  //
  // ⚠️ `org.node.*` — daraxt tugunlari (bosh ofis, filial, bo'lim,
  // ombor, agent, reseller). `org.type.write` — TUR ta'rifi
  // (`platform.org_node_type`): administrator yangi birlik turini
  // ochishi va uning imkoniyatlarini belgilashi. Ular ATAYLAB
  // ajratilgan: tugun yaratish kundalik ish, tur ta'rifini o'zgartirish
  // esa butun tizim xulqiga tegadi (§19.3 — kod tur NOMIGA emas,
  // IMKONIYATIGA qaraydi).
  'org.node.read',
  'org.node.write',
  'org.type.write',
  'user.read',
  'user.create',
  // ⚠️ Backend allaqachon yuboradi (`Permission.USER_UPDATE`), katalogda esa
  // YO'Q edi va `authApi.toCurrentUser` uni jimgina tashlab yuborardi. Natija:
  // parol o'zgartirish / bloklash / TOTP reset tugmalari huquqi BOR operatorga
  // ham ko'rinmasdi. `user.create` bilan chalkashtirmang: "yangi xodim qo'sha
  // oladi" va "boshqa xodimning parolini almashtira oladi" boshqa daraja.
  'user.update',
  // Odamni tashkilotdan chiqarish (`DELETE /api/users/{id}`). Bu HISOBNI
  // o'chirmaydi — server `identity.app_user` qatorini SAQLAYDI, chunki
  // `platform.audit_log.actor_id` FK'siz xom matn. Kod bu ro'yxatda
  // bo'lmasa, `authApi.toCurrentUser` uni jimgina tashlab yuborardi va
  // huquqi BOR administratorda ham "Chiqarish" tugmasi ko'rinmasdi.
  'user.delete',
  'user.role.assign',
  'role.read',
  'role.create',
  'role.update',
  // ⚠️ D2 (2026-08-15) — faqat BO'SH va tizim bo'lmagan rolni o'chiradi.
  // Ro'yxatda bo'lmasa `authApi.toCurrentUser` uni JIMGINA tashlab
  // yuboradi va huquqi BOR operator uchun ham tugma ko'rinmasdi.
  'role.delete',
  'psp.read',
  'psp.configure',

  // 2-yo'nalish: mehmonxona/kafe
  'venue.read',
  'venue.create',
  'venue.update',
  'portal.template.update',
  'campaign.manage',
  // Ob'ekt xodimi mehmonga QO'LDA kirish beradi (resepshn stsenariysi).
  // ⚠️ Bu kod katalogda YO'Q edi va oqibati ikki qavatli: `authApi` uni
  // jimgina tashlab yuborardi (huquqi bor xodimda ham `can(...)` yolg'on
  // qaytarardi), rol konstruktorida esa u umuman ko'rinmasdi — ya'ni
  // huquqni ROLGA BERIB HAM bo'lmasdi. Serverda u bor
  // (`Permission.VENUE_GUEST_GRANT`), farqni `tests/roles-page.mjs`
  // endi har yurishda tekshiradi.
  'venue.guest.grant',

  // Bildirishnomalar — manba: `notify/internal/*Controller.java`,
  // sakkiztasi ham dedikatsiya qilingan (ilgari `settings.*`/`audit.read`/
  // `subscriber.update` dan qarzga olingan edi, konsolidatsiya auditida
  // almashtirilgan — kontroller javadoc'lariga qarang)
  'notify.template.read',
  'notify.template.write',
  'notify.subscription.read',
  'notify.subscription.write',
  'notify.message.read',
  'notify.quiethours.read',
  'notify.quiethours.write',
  'notify.telegram.link',
  // WhatsApp Business ulanishi — ko'rish ham shu kod bilan, alohida `.read` yo'q
  'notify.whatsapp.manage',

  // CRM — manba: `backend/.../Permission.java` (`crm.*`, 11 ta).
  //
  // ⚠️ Bu o'n bittasi katalogda YO'Q edi va sabab `user.update` bilan
  // AYNAN BIR XIL: `authApi.toCurrentUser` notanish kodni jimgina
  // tashlab yuboradi, ya'ni huquqi BOR operator uchun ham
  // `can(...)` shu kodlar bo'yicha HECH QACHON rost bo'lmaydi. Bugun panelda
  // CRM sahifasi yo'q, shuning uchun ko'rinadigan zarar yo'q — lekin
  // birinchi CRM sahifasi qo'shilgan kuni u BARCHA rollarda bo'sh
  // ko'rinardi va sabab bu faylda emas, o'sha sahifada qidirilardi.
  'crm.ticket.read',
  'crm.ticket.create',
  'crm.ticket.update',
  'crm.ticket.close',
  'crm.interaction.read',
  'crm.interaction.create',
  // ⚠️ Bu ikkisi katalogda BO'LMASA, huquqi BOR operator uchun ham
  //    tugma ko'rinmaydi: `authApi.toCurrentUser` notanish kodni
  //    JIMGINA tashlab yuboradi. Loyihada shu xato to'rt marta sodir
  //    bo'lgan — `V202608520001` migratsiyasining oxirgi bo'limi.
  'crm.interaction.update',
  'crm.interaction.void',
  'crm.lead.read',
  'crm.lead.create',
  'crm.lead.update',
  'crm.lead.reveal',
  'crm.lead.convert',
  // ⚠️ `inventory.*` va `site.*` bu yerga TAKRORLANMAYDI — ular
  // yuqorida, "Infratuzilma" bo'limida turibdi.

  // Davomat (yuzni tanish terminallari) — manba:
  // `backend/migration/.../V202608110100__attendance_init.sql` va
  // `uz.xsib.common.security.Permission`.
  //
  // ⚠️ Sakkiztasi ham SHU YERDA bo'lishi SHART, garchi hozircha faqat
  // Qurilmalar sahifasi mavjud bo'lsa ham. Sabab `user.update`,
  // `venue.guest.grant` va CRM ning 11 ta kodi bilan uch marta sodir
  // bo'lgan: katalogda yo'q kodni `authApi.toCurrentUser` JIMGINA tashlab
  // yuboradi, ya'ni huquqi BOR operator uchun ham `can(...)` hech qachon
  // rost bo'lmaydi va sahifa bo'sh ko'rinadi. Sabab esa o'sha sahifada
  // qidirilardi, bu faylda emas. Qolgan uchta sahifa (xodimlar, hodisalar,
  // hisobot) keyingi bosqichda qo'shiladi — huquqlar esa hozirdanoq rol
  // konstruktorida ko'rinib tursin.
  'attendance.device.read',
  'attendance.device.write',
  // Qurilmaga xodim/yuz yuborish navbatini qo'lda turtish. `.write` dan
  // ALOHIDA: birinchisi bazadagi yozuvni o'zgartiradi, bu esa TASHQI
  // qurilmaga chaqiruv qiladi va noto'g'ri parolda Hikvision manzilni
  // ~30 daqiqaga qulflaydi (migratsiya izohi).
  'attendance.device.sync',
  'attendance.employee.read',
  'attendance.employee.write',
  'attendance.event.read',
  'attendance.report.read',
  // ⚠️ XAVFLI HUQUQ va ATAYLAB ALOHIDA. Eshikni masofadan ochish —
  // jismoniy kirish berish demak. Uni "davomat hisobotini ko'rish" bilan
  // bitta kodga birlashtirish eng kam imtiyoz tamoyilini buzardi:
  // hisobotchi xodim binoga kira oladigan bo'lib qolardi.
  'attendance.door.open',

  // Kadrlar (`xsib-hr`) — manba:
  // `backend/migration/.../V202608131300__identity_hr_permissions.sql` va
  // `uz.xsib.common.security.Permission`.
  //
  // ⚠️ To'rttasi ham SHU YERDA bo'lishi SHART, garchi kadrlar SAHIFALARI
  // hali yo'q bo'lsa ham. Sabab `user.update`, `venue.guest.grant`, CRM
  // ning 11 kodi va `org.*` ning 3 kodi bilan TO'RT marta sodir bo'lgan:
  // katalogda yo'q kodni `authApi.toCurrentUser` JIMGINA tashlab yuboradi,
  // ya'ni huquqi BOR operator uchun ham `can(...)` hech qachon rost
  // bo'lmaydi. Huquqlar hozirdanoq rol konstruktorida ko'rinib tursin.
  'hr.person.read',
  'hr.person.write',
  'hr.person.document.view',
  // Tayinlash — tugun, lavozim, ish turi. `.write` dan ALOHIDA: telefon
  // raqamini tuzatish yozuvni tahrirlaydi, xodimni boshqa filialga
  // ko'chirish esa UNI KIM KO'RISHINI o'zgartiradi (SUBTREE doirasi
  // tayinlangan tugunga tayanadi).
  'hr.employment.write',
  // Lavozim KATALOGI — bir necha xodim yozuvida takrorlanadi va
  // kelajakdagi maosh hisobotining o'lchovi bo'ladi.
  'hr.jobtitle.write',

  // --- Kadrlar: ISH HAQI va TA'TIL ------------------------------------
  // Manba: `backend/migration/.../V202608150700__identity_hr_pay_permissions.sql`
  // va `uz.xsib.common.security.Permission`.
  //
  // ⚠️⚠️ O'N IKKITASINING BIRORTASI HAM `.read` BILAN TUGAMAYDI — bu
  // YOZUV XATOSI EMAS, `finance.*` va `job.run.view` bilan AYNAN bir
  // xil sabab. `identity.seed_system_roles()` `%.read` bilan tugagan
  // har huquqni `VIEWER`/`SUPPORT`/`MODERATOR` shablonlariga
  // O'Z-O'ZIDAN qo'shadi. `V202608131200__hr_init.sql` buni "MUDDATI
  // BOR OGOHLANTIRISH" deb yozgan edi: *"maosh qo'shilgan kuni qayta
  // ko'rib chiqilsin"*. Ko'rib chiqildi va nom shakli tanlandi
  // (`V202608150600` 8-bo'limi). Bu kodlarni `.read` ga
  // "to'g'irlash" har kuzatuvchiga butun tashkilotning maoshini
  // ochib qo'yadi.
  //
  // ⚠️ SAHIFALAR HALI YO'Q. Kodlar baribir SHU YERDA bo'lishi SHART:
  // katalogda yo'q kodni `authApi.toCurrentUser` JIMGINA tashlaydi va
  // rol konstruktorida ular umuman ko'rinmasdi — ya'ni administrator
  // "kadr bo'limi" rolini tuzganda maosh huquqini BERA OLMASDI va
  // sabab bu faylda emas, sahifada qidirilardi.

  // ⚠️ XAVFLI (backendda `Permission.DANGEROUS`, panelda qizil
  // ogohlantirish). Tizimdagi eng nozik OSHKORLIK: doiradagi HAR
  // xodimning maoshini ochadi. `crm.lead.reveal` bilan bir xil toifa
  // — hech narsani buzmaydi, shaxsiy ma'lumotni OCHADI.
  'hr.salary.view',
  // Maosh belgilash va ustama qo'shish. ⚠️ Xavfli deb BELGILANMAGAN va
  // bu ataylab: noto'g'ri maosh vedomost yig'ilgunga qadar yangi davr
  // bilan tuzatiladi va hech kimga hech narsa ochilmaydi. Bu kadr
  // bo'limining kundalik ishi — uni qizil bayroq bilan belgilash
  // ogohlantirishni SHOVQINGA aylantirardi.
  'hr.salary.write',
  // Ish haqi qismlari KATALOGI (ustama, avans, jarima). `finance.account.write`
  // bilan bir xil toifa: qism qo'shish ma'lumotnomaga qator qo'shish
  // emas, PULNING YO'NALISHINI belgilash — `DEDUCTION` qo'yilgan qism
  // har vedomostda ayriladi.
  'hr.paycomponent.write',

  // ⚠️ XAVFLI. Vedomost — o'sha maosh ma'lumotining filial bo'yicha
  // yig'ma ko'rinishi. Uni ogohlantirishsiz qoldirish
  // `hr.salary.view` ni qo'riqlashning ma'nosini yo'qotardi: bir xil
  // ma'lumot ikkinchi eshikdan ochiq chiqardi.
  'hr.payroll.view',
  // Vedomost YIG'ISH — faqat LOYIHA holatida. Tasdiqlashdan ALOHIDA va
  // bu mijoz hujjatining so'zma-so'z talabi ("review and approve
  // payroll before payment"): bitta kod bo'lsa, yig'gan odam o'zi
  // tasdiqlardi va "ko'rib chiqish" bosqichi hech qanday to'siq
  // bo'lmasdi.
  'hr.payroll.run',
  // ⚠️ XAVFLI. Tasdiqlash TO'LOV MAJBURIYATINI yaratadi va QAYTARIB
  // BO'LMAYDI: satrlar muzlaydi, holat orqaga qaytmaydi.
  // `finance.period.close` bilan bir xil toifa. Panel bu tugmani
  // tasdiqlash oynasisiz ko'rsatmasligi kerak.
  'hr.payroll.approve',

  // ⚠️ XAVFLI. Bank rekvizitlari — shaxsiy ma'lumot va firibgarlikning
  // nishoni. Ko'rish ham xavfli: hisob raqamlari ro'yxati chetga
  // chiqsa, undan keyingi zarar tizimdan TASHQARIDA bo'ladi.
  'hr.bank.view',
  // ⚠️ XAVFLI, va ro'yxatdagi eng "jimgina" xavf: hisob raqamini
  // almashtirish hech narsani buzmaydi va hech narsani oshkor
  // qilmaydi — u shunchaki keyingi maoshni BOSHQA ODAMGA yuboradi.
  // Nuqson faqat to'lovdan KEYIN ko'rinadi.
  'hr.bank.write',

  // Ta'til so'rovlari va balansi.
  'hr.leave.view',
  // Ta'til SO'RASH va bekor qilish. Tasdiqlashdan ALOHIDA: xodimning
  // o'zi (`OWN` doira bilan) so'rov yozadi, tasdiqni boshliq beradi.
  // Bitta kod bo'lsa, `OWN` doiradagi xodim o'z ta'tilini o'zi
  // tasdiqlardi.
  'hr.leave.request',
  'hr.leave.approve',
  // Ta'til turlari KATALOGI. Alohida, chunki yillik kun soni QONUNIY
  // HUQUQNI belgilaydi: uni o'zgartirish butun tashkilotning ta'til
  // balansini qayta hisoblaydi (balans saqlanmaydi, so'ralganda
  // hisoblanadi — QARORLAR.md §20.1).
  'hr.leavetype.write',
  // Xodimni baholash. `.read` bilan tugamaydi — ko'ruvchi rollarga o'z-o'zidan tushmasin.
  'hr.rating.view',
  'hr.rating.write',
  'hr.ratingcriterion.write',

  // Moliya (`xsib-finance`) — manba:
  // `backend/migration/.../V202608131900__identity_finance_permissions.sql`
  // va `uz.xsib.common.security.Permission`.
  //
  // ⚠️ Oltitasi ham SHU YERDA bo'lishi SHART, garchi moliya SAHIFALARI
  // hali yo'q bo'lsa ham. Bu xato loyihada BESH marta sodir bo'lgan
  // (`user.update`, `venue.guest.grant`, CRM ning 11 kodi, `org.*` ning
  // 3 kodi, `hr.*` ning 4 kodi): katalogda yo'q kodni
  // `authApi.toCurrentUser` JIMGINA tashlab yuboradi, ya'ni huquqi BOR
  // operator uchun ham `can(...)` hech qachon rost bo'lmaydi va sahifa
  // ko'rinmaydi. Xato ekranda emas, YO'QLIKDA ko'rinadi.
  //
  // ⚠️⚠️ KODLAR `.view` BILAN TUGAYDI, `.read` BILAN EMAS — bu YOZUV
  // XATOSI EMAS. `identity.seed_system_roles()` `%.read` bilan tugagan
  // har huquqni `VIEWER`/`SUPPORT`/`MODERATOR` ga O'Z-O'ZIDAN qo'shadi,
  // moliya esa MAXFIY sxema (QARORLAR.md §20.3 audit tuzatishi):
  // "Kuzatuvchi" butun tashkilotning foydasi va xarajatini ko'rib
  // turishi #57 ning takrori bo'lardi. Bu kodlarni `.read` ga
  // "to'g'irlash" o'sha teshikni ochib qo'yadi.
  'finance.account.view',
  'finance.account.write',
  'finance.period.view',
  // Davr OCHISH — qaytariladigan amal (bo'sh davrni o'chirish mumkin).
  'finance.period.create',
  // ⚠️ XAVFLI HUQUQ va ATAYLAB ALOHIDA. Davrni yopish PUL YOZADI
  // (ledger agregatidan yig'ma provodka) va QAYTARIB BO'LMAYDI:
  // yopilgan davr o'zgarmas, qayta ochish YO'Q. Panel bu tugmani
  // tasdiqlash oynasisiz ko'rsatmasligi kerak.
  'finance.period.close',
  // Xarajat kiritish — kundalik ish. Hisoblar rejasini o'zgartirishdan
  // (`finance.account.write`) ALOHIDA: birinchisini buxgalter qiladi,
  // ikkinchisi tuzilmaviy qaror.
  'finance.expense.write',
  'finance.dashboard.view',

  // Fon vazifalari sahifasi (`xsib-platform` `job` moduli) — manba:
  // `backend/migration/.../V202608140200__identity_job_permissions.sql`
  // va `uz.xsib.common.security.Permission.JOB_RUN_VIEW`.
  //
  // ⚠️ Bu bitta kod SHU YERDA bo'lishi SHART. Yuqoridagi olti guruh
  // (`user.update`, `venue.guest.grant`, CRM ning 11 kodi, `org.*` ning
  // 3 kodi, `hr.*` ning 4 kodi, `finance.*` ning 6 kodi) AYNAN shu
  // xatoning oltita takrori: katalogda yo'q kodni
  // `authApi.toCurrentUser` **jimgina tashlaydi**, ya'ni huquqi BOR
  // operator uchun ham `can('job.run.view')` hech qachon rost bo'lmaydi
  // va sahifa umuman ko'rinmaydi — na xato, na konsolda belgi.
  //
  // ⚠️⚠️ BU YERDA XATO IKKI BARAVAR ACHCHIQ bo'lardi. Sahifaning butun
  // vazifasi — JIMGINA o'lgan mexanizmni ko'rsatish (2026-08-13,
  // `EventPullJob`). Uni ko'rsatadigan sahifaning o'zi jimgina
  // yo'qolishi o'sha nosozlik turining aynan takrori bo'lardi.
  //
  // ⚠️ Kod `.view` bilan tugaydi, `.read` bilan EMAS — bu YOZUV XATOSI
  // EMAS, `finance.*` bilan bir xil sabab: `identity.seed_system_roles()`
  // `%.read` bilan tugagan har huquqni `VIEWER`/`SUPPORT`/`MODERATOR`
  // shablonlariga O'Z-O'ZIDAN qo'shadi. Bu sahifa esa mijoz ma'lumotini
  // emas, PLATFORMANING ichki holatini ko'rsatadi (qaysi servisda
  // rejalashtiruvchi ushlamayapti, nima qancha vaqtdan beri yiqilgan) —
  // bu operatorning ishi. Kodni `.read` ga "to'g'irlash" uni har bir
  // kuzatuvchiga ochib qo'yadi.
  'job.run.view',
] as const

export type Permission = (typeof PERMISSIONS)[number]

/** Ko'rinish doirasi — 04-ROLES.md §4 */
export const SCOPE_TYPES = ['GLOBAL', 'TENANT', 'SUBTREE', 'OWN', 'VENUE'] as const
export type ScopeType = (typeof SCOPE_TYPES)[number]

/**
 * Serverdan kelgan noma'lum satrni `Permission` ga tekshiradi.
 *
 * Backend biz bilmaydigan yangi huquq yuborishi mumkin (u yangilangan, panel
 * hali yo'q). Bunday nom shunchaki e'tiborsiz qoldiriladi — panel yiqilmasin.
 */
export function isPermission(value: string): value is Permission {
  return (PERMISSIONS as readonly string[]).includes(value)
}
